var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footBar"},[_vm._m(0),_c('p',[_vm._v(" © 2024 by "+_vm._s('上海鼎胜机械设备有限公司版权所有')+" 皖ICP备2024066770号-1 ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',[_vm._v("联系地址：上海市宝山区罗泾镇飞腾路168号")]),_c('span',[_vm._v("联系电话：13816064096")]),_c('span',[_vm._v("邮箱：2875520218@qq.com")])])
}]

export { render, staticRenderFns }